import { Button, ButtonTargetKind } from "src/components/Button";
import { Modal, ModalProps } from "src/components/Modal";
import { FundraiserEditFormKind } from "src/pages/Fundraiser/EditForm/types";
import { ButtonRole, ButtonSize } from "src/styles/button";
import { verticalStackCss, horizontalStackCss } from "src/theme/spacing";

interface CancelConfirmationModalProps extends Pick<ModalProps, "isOpen"> {
  onConfirm: () => void;
  onReject: () => void;
  editKind: FundraiserEditFormKind;
}

export const CancelConfirmationModal = (
  props: CancelConfirmationModalProps
) => (
  <Modal isOpen={props.isOpen} onRequestClose={props.onReject}>
    <div css={verticalStackCss.l}>
      <p>
        {props.editKind === FundraiserEditFormKind.EDIT
          ? "Are you sure you want to cancel all your changes?"
          : "Are you sure you want to cancel this fundraiser?"}
      </p>
      <div css={horizontalStackCss.s}>
        <Button
          data-tname="fundraiserEditContinue"
          role={ButtonRole.SECONDARY}
          size={ButtonSize.SMALL}
          css={{ marginLeft: "auto" }}
          onClick={{
            kind: ButtonTargetKind.FUNCTION,
            action: props.onReject,
          }}
        >
          Continue editing
        </Button>
        <Button
          data-tname="fundraiserEditCancel"
          role={ButtonRole.PRIMARY}
          size={ButtonSize.SMALL}
          onClick={{
            kind: ButtonTargetKind.FUNCTION,
            action: props.onConfirm,
          }}
        >
          {props.editKind === FundraiserEditFormKind.EDIT
            ? "Discard changes"
            : "Cancel fundraiser"}
        </Button>
      </div>
    </div>
  </Modal>
);
